export { LanguageSingleton as default };

import LanguageData from '@/js/Shared/Language/Locales/pt-PT';

/**
* Language Controller for multiple i18n locales
*
* When local storage is disabled, saves all keys in memory
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class Language {

  data = LanguageData;

  /**
   * Sets an item in the Session Storage
   *
   * @since 7.0.0
   *
   * @param {string} key          data key
   * @param {Array}  replacements data to be storage
   *
   * @return {string}
   */
  say(key, replacements = []) {
    if (!key) {
      return;
    }

    let drill = this.data;

    key.split('.').forEach(function(item) {
      if (drill[item]) {
        drill = drill[item];
      }
    })

    if (typeof drill !== 'string') {
      return key;
    }

    if (replacements) {
      drill = drill.replace('%s1', replacements[0]);
    }

    if (replacements[1]) {
      drill = drill.replace('%s2', replacements[1]);
    }

    return drill;
  }

  pluralize(key, count) {
    key += (count > 1) ? '_plural' : '_singular';
    return this.say(key, [count]);
  }
}

const LanguageSingleton = new Language();